export const getHeaderHeight = () => {
  const header = document.getElementsByTagName('header')[0];
  let headerHeight = header.offsetHeight;

  // Prevent calculate headerheight wrong, due to shrink animation
  if (window.innerWidth > 1200 && document.documentElement.scrollTop < 100) headerHeight = 86;
  return headerHeight;
}


// WEBPACK FOOTER //
// ./src/utils/navigation.js